export default __webpack_public_path__ + "images/a975512af1947892ab2203b54ef5ca63-2_tablet_1067x470.webp";